import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10d5c287&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import "./index.vue?vue&type=style&index=0&id=10d5c287&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5c287",
  null
  
)

export default component.exports